const STORAGE_KEY = 'recon.filesViewMode';
const MODES = ['list', 'thumbnail'];

export function getFilesViewMode() {
	try {
		const value = localStorage.getItem(STORAGE_KEY);
		if (MODES.includes(value)) return value;
	} catch (e) {
		// ignore
	}
	return 'list';
}

export function setFilesViewMode(mode) {
	const next = MODES.includes(mode) ? mode : 'list';
	try {
		localStorage.setItem(STORAGE_KEY, next);
	} catch (e) {
		// ignore
	}
	return next;
}
